/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import OrganizationAPI from '@/api/OrganizationAPI.js';
import SubscriberAPI from '@/api/SubscriberAPI.js';
import UserTaxAPI from '@/api/UserTaxAPI.js';
import AccountAPI from '@/api/AccountAPI.js';
import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';

export default {
	/**
	 * Láº¥y danh sÃ¡ch phÃ²ng ban á»Ÿ pháº§n chá»n nhanh chi nhÃ¡nh lÃ m viá»‡c
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	loadOrganizationsUnit: async function(context, payload) {
		var data = await context.dispatch('loadAllOrganizationsUnit', payload);
		if (data && data.length > 0) {
			if (!payload || (payload && !payload.textSearch)) {
				context.commit('updateOrganizationsUnit', data);
			}
			return data;
		}
		return [];
	},

	/**
	 * Láº¥y danh sÃ¡ch cÆ¡ cáº¥u tá»• chá»©c
	 */
	loadOrganizations: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: OrganizationAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/alltreestructure',
				params: payload
			},
			true,
			true
		);

		if (res && res.Success) {
			context.commit('updateOrganizations', res.Data);
			return res.Data;
		}

		return [];
	},

	/**
	 * thá»±c hiá»‡n call server load ra danh sÃ¡ch CCTC theo dáº¡ng tree
	 */
	loadAllOrganizationsUnit: async function(context, payload) {
		if (!payload) {
			payload = {};
		}
		let isShowLoading = payload.isShowLoading ? true : false;
		if (payload.isShowLoading) delete payload.isShowLoading;
		let res = await httpClient.getAsync(
			{
				url: OrganizationAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/alltree',
				params: payload
			},
			isShowLoading,
			false
		);
		if (res && res.Success) {
			return res.Data;
		}
		return [];
	},

	/**
	 * Láº¥y táº¥t cáº£ danh sÃ¡ch CÆ¡ cáº¥u tá»• chá»©c dáº¡ng case Ä‘á»ƒ sá»­ dá»¥ng cho cÃ¡c combox lá»c
	 */
	loadAllTreeOrganizations: async function(context, payload) {
		var data = await context.dispatch('loadAllOrganizationsUnit', payload);
		if (data && data.length > 0) {
			context.commit('updateAllTreeOrganizations', data);
			return data;
		}
		return [];
	},
	/**
	 * Láº¥y táº¥t cáº£ danh sÃ¡ch CÆ¡ cáº¥u tá»• chá»©c theo Subscribers
	 */
	loadOrganizationBySubscriber: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: OrganizationAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/all',
				params: payload
			},
			false,
			false
		);

		if (res && res.Success) {
			context.commit('updateAllOrganizations', res.Data);
			return res.Data;
		}

		return [];
	},
	addOrganizationsUnit: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: OrganizationAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()),
				data: payload
			},
			true
		);
		return res.data || res;
	},

	editOrganizationsUnit: async function(context, payload) {
		let res = await httpClient.putAsync(
			{
				url: OrganizationAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + `/${payload.orgNext.Id}`,
				data: payload
			},
			true
		);

		return res;
	},

	deleteOrganizationsUnit: async function(context, payload) {
		let res = await httpClient.deleteAsync(
			{
				url:
					OrganizationAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) +
					`/${commonFunc.getOrgParamOrgOnly()}/${payload.Id}`
			},
			true
		);

		return res;
	},

	updateOrganizationWorking: async function(context, payload) {
		//Gọi lên backend để cập nhật
		let res = await httpClient.putAsync(
			{
				url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/workingorg',
				params: { orgId: payload.Id }
			},
			false,
			false
		);

		//Kiểm tra xem có cần reset router không
		var resetRouter = true;
		if (payload.resetRouter != undefined) {
			resetRouter = payload.resetRouter;
			delete payload.resetRouter;
		}

		//Gọi cập nhật đơn vị làm việc thành công
		if (res && res.Data) {
			context.commit(
				'updateOrganizationWorking',
				Object.assign({}, payload, {
					InvoiceCount: res.Data.InvoiceCount,
					OutInvoiceCount: res.Data.OutInvoiceCount,
					DeclarationCount: res.Data.DeclarationCount
				})
			);
		} else {
			context.commit('updateOrganizationWorking', payload);
		}

		//Nếu cần phải reset router
		if (resetRouter) this.commit('updateRouterIndex');

		//Trả kết quả
		return res;
	},

	getOrganizationsUnitByID: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: OrganizationAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + `/${payload.Id}`
		});
		if (res && res.Success) {
			// context.commit('getOrganization', res.Data);
			return res.Data;
		}

		return null;
	},

	getInfoByTaxCode: async function(context, payload) {
		if (!payload) {
			return null;
		}
		//trim cÃ¡c khoáº£ng trÄƒng cá»§a mÃ£ sá»‘ thuáº¿
		payload = payload.trim();
		let res = await httpClient.getAsync(
			{
				url: OrganizationAPI.getAPIUrl() + `/suggest/${payload}`
			},
			false
		);
		if (res && res.Success) {
			return res.Data;
		}

		return null;
	},

	getInfoByIdentityCode: async function(context, payload) {
		if (!payload) {
			return null;
		}
		//trim cÃ¡c khoáº£ng trÄƒng cá»§a mÃ£ sá»‘ thuáº¿
		payload = payload.trim();
		let res = await httpClient.getAsync(
			{
				url: OrganizationAPI.getAPIUrl() + `/suggestv2/${payload}`
			},
			false
		);
		if (res && res.Success) {
			return res.Data;
		}

		return null;
	},

	addSubscriber: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: SubscriberAPI.getAPIUrl(),
				data: payload
			},
			true
		);

		if (res) {
			return res.data || res;
		}

		return null;
	},

	getSubscriber: async function(context, payload) {
		const subscriberCode = localStorage.getItem('SubscriberCode');
		let res = await httpClient.getAsync(
			{
				url: SubscriberAPI.getAPIUrl() + `/code/${subscriberCode}?isFromInbot=true`
			},
			true
		);

		//ThÃ nh cÃ´ng
		if (res && res.Success) {
			context.commit('updateSubscriberWorking', res.Data);
			return res.Data;
		}

		//KhÃ´ng tÃ¬m tháº¥y Subscriber
		if (res && (res.status == 404 || res.ErrorCode == '422')) {
			//TH láº¥y dá»¯ liá»‡u sub khÃ´ng láº¥y Ä‘Æ°á»£c
			//Cached trong storage cá»§a Subscriber váº«n cÃ³ dá»¯ liá»‡u mÃ  khÃ¡c vá»›i request nÃ y => Ä‘Ã¢y lÃ  client khÃ¡c
			//Kiá»ƒm tra xem náº¿u client lÃ  1 client khÃ¡c vá»›i dá»¯ liá»‡u trong store
			//thÃ¬ tá»± Ä‘á»™ng reset háº¿t cache trong client cá»§a client trÆ°á»›c Ä‘Ã³ Ä‘i
			const checkClientOther =
				context &&
				context.getters &&
				context.getters.getSubscriberWorking &&
				context.getters.getSubscriberWorking.Code &&
				context.getters.getSubscriberWorking.Code !== subscriberCode;
			if (checkClientOther) {
				await commonFunc.resetStateDefault();
			}
		}

		return null;
	},

	getSubscriberByTaxCode: async function(context, payload) {
		return await httpClient.getAsync(
			{
				url: SubscriberAPI.getAPIUrl() + `/code/${payload.TaxCode}`
			},
			true
		);
	},

	getSubscriberFromMeinvoice: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: SubscriberAPI.getAPIUrl() + `/sugguest?isFromInbot=true`
		});
		if (res) {
			return res.Data;
		}
		return null;
	},

	/**
	 * Láº¥y giÃ¡ trá»‹ cÃ¡c thÃ´ng tin tá»« key kÃ­ch hoáº¡t
	 */
	checkKeyStore: async function(context, payload) {
		return await httpClient.getAsync(
			{
				url: SubscriberAPI.getAPIUrl() + `/checkstore/${payload.Key}`
			},
			true
		);
	},

	/**
	 * KÃ­ch hoáº¡t mÃ£ tá»« bÃªn store
	 */
	activeKeyStore: async function(context, payload) {
		return await httpClient.postAsync(
			{
				url: SubscriberAPI.getAPIUrl() + `/active`,
				data: payload
			},
			true
		);
	},

	/**
	 * Kiá»ƒm tra mÃ£ sá»‘ thuáº¿ vÃ  tÃ i khoáº£n Ä‘Ã£ Ä‘Äƒng kÃ½ meinvoice hay chÆ°a
	 */
	checkTaxCodeMeinvoice: async function(context, payload) {
		return await httpClient.postAsync(
			{
				url: SubscriberAPI.getAPIUrl() + `/checkusermei`,
				data: payload
			},
			false
		);
	},

	/**
	 * Láº¥y ra userId cá»§a meinvoice khi Ä‘Äƒng kÃ½ thÃ nh cÃ´ng Ä‘á»ƒ active
	 */
	getUserIdMei: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: SubscriberAPI.getAPIUrl() + `/getuseridmeinvoice`,
				data: payload
			},
			false
		);
		if (res) {
			return res.Data;
		}
		return null;
	},

	/**
	 * Kiá»ƒm tra mÃ£ sá»‘ thuáº¿ Ä‘Ã£ Ä‘Äƒng kÃ½ meinvoice hay chÆ°a
	 */
	checkUserMeibyTaxCode: async function(context, payload) {
		return await httpClient.getAsync(
			{
				url: SubscriberAPI.getAPIUrl() + `/checkusermeibytaxcode/${payload.TaxCode}`
			},
			false
		);
	},

	/**
	 * ÄÄƒng kÃ½ tÃ i khoáº£n meinvoice
	 */
	registerMeinvoice: async function(context, payload) {
		return await httpClient.postAsync(
			{
				url: SubscriberAPI.getAPIUrl() + `/registerMeinvoice`,
				data: payload
			},
			false
		);
	},

	/**
	 * ÄÄƒng kÃ½ user Ä‘i theo mÃ£ sá»‘ thuáº¿
	 */
	registerUserMeinvoice: async function(context, payload) {
		return await httpClient.postAsync(
			{
				url: SubscriberAPI.getAPIUrl() + `/registerusermeinvoice`,
				data: payload
			},
			false
		);
	},

	/**
	 * ÄÄƒng kÃ½ user Ä‘i theo mÃ£ sá»‘ thuáº¿ khÃ´ng misaId
	 */
	registerUserMeinvoiceNotMisaId: async function(context, payload) {
		return await httpClient.postAsync(
			{
				url: SubscriberAPI.getAPIUrl() + `/registerusermeinvoicenotmisaid`,
				data: payload
			},
			false
		);
	},

	/// Kiá»ƒm tra sá»‘ Ä‘iá»‡n thoáº¡i email misa id
	checkAccountMisaId: async function(context, payload) {
		return await httpClient.postAsync(
			{
				url: SubscriberAPI.getAPIUrl() + `/exist`,
				data: payload
			},
			true
		);
	},

	/// Kiá»ƒm tra sá»‘ Ä‘iá»‡n thoáº¡i email misa id
	searchMisaId: async function(context, payload) {
		return await httpClient.postAsync(
			{
				url: SubscriberAPI.getAPIUrl() + `/searchmisaid`,
				data: payload
			},
			true
		);
	},

	updateHiddenTip: async function(context, payload) {
		context.commit('updateHiddenTip');
	},

	/**
	 * Táº¡o chi nhÃ¡nh, phÃ²ng ban láº§n Ä‘áº§u
	 */
	createOrganizationFirst: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: OrganizationAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + `/createdfirst`,
				data: payload
			},
			true
		);
		return res.data || res;
	},

	/**
	 * Kiá»ƒm tra hÃ³a Ä‘Æ¡n
	 */
	checkLoginTCT: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: OrganizationAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + `/logintct/${payload}`
			},
			true
		);
		if (res && res.Success) {
			return res.Data;
		}
		return null;
	},

	/**
	 * Láº¥y táº¥t cáº£ danh sÃ¡ch CÆ¡ cáº¥u tá»• chá»©c dáº¡ng cÃ¢y
	 * KhÃ´ng cáº§n biáº¿t cÃ³ quyá»n hay khÃ´ng láº¥y háº¿t danh sÃ¡ch
	 */
	loadFullTreeOrganizations: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: OrganizationAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/fulltree',
				params: payload
			},
			true
		);
		if (res && res.Success) {
			context.commit('updateFullTreeOrganizations', res.Data);
			return res.Data;
		}
		return null;
	},

	/**
	 *Láº¥y token cho thÃ´ng bÃ¡o gia háº¡n, tÃ i nguyÃªn
	 */
	getTokenNotification: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: SubscriberAPI.getAPIUrl() + `/tokennotificationstore`,
				data: payload
			},
			false
		);
		if (res && res.Data) return res.Data;
		return res;
	},

	updateEmailReceiveOrg: async function(context, payload) {
		return await httpClient.postAsync(
			{
				url: `${OrganizationAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly())}/emailreceive/${
					payload && payload.OrganizationId ? payload.OrganizationId : ''
				}`,
				data: payload
			},
			true
		);
	},

	/**
	 * Tra cá»©u thÃ´ng tin doanh nghiá»‡p theo mÃ£ Ä‘á»‹nh danh (MST hoáº·c CCCD)
	 * @param {Object} context - Vuex context
	 * @param {Object} payload - Dá»¯ liá»‡u yÃªu cáº§u
	 * @param {string} payload.TaxCode - MÃ£ sá»‘ thuáº¿ hoáº·c CCCD (báº¯t buá»™c)
	 * @param {string} payload.SellerName - TÃªn ngÆ°á»i bÃ¡n (tÃ¹y chá»n, dÃ¹ng cho CCCD)
	 * @param {string} payload.SellerAddress - Äá»‹a chá»‰ ngÆ°á»i bÃ¡n (tÃ¹y chá»n, dÃ¹ng cho CCCD)
	 * @returns {Object|null} ThÃ´ng tin doanh nghiá»‡p hoáº·c null náº¿u khÃ´ng tÃ¬m tháº¥y
	 * @description API nÃ y tá»± Ä‘á»™ng phÃ¢n biá»‡t MST vÃ  CCCD, vá»›i CCCD sáº½ sá»­ dá»¥ng location determination
	 */
	getOrgInfoByIdentityCode: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: OrganizationAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + `/orginfo`,
				data: payload
			},
			true
		);

		if (res.Success && res.Data) {
			return res.Data;
		}

		return null;
	},

	/**
	 * Cáº­p nháº­t CCCD cho cÃ¡c tá»• chá»©c Ä‘Æ°á»£c chá»n
	 * @param {Object} context - Vuex context
	 * @param {Object} payload - Dá»¯ liá»‡u cáº­p nháº­t
	 * @param {Array<string>} payload.OrganizationIds - Danh sÃ¡ch ID tá»• chá»©c
	 * @param {string} payload.IdentificationNumber - Sá»‘ CCCD tá»« license
	 * @returns {Object} Káº¿t quáº£ cáº­p nháº­t
	 * @description Cáº­p nháº­t CCCD vÃ  chuyá»ƒn cÃ¡c Ä‘Æ¡n vá»‹ thÃ nh loáº¡i "Há»™ kinh doanh"
	 */
	updateOrganizationIdentification: async function(context, payload) {
		return await httpClient.postAsync(
			{
				url: OrganizationAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/update-identification',
				data: payload
			},
			true
		);
	}
};
